<div class="content-align" [dir]="data.dir">
	<ng-container *ngIf="readConfigFrom; else sameResourceConfig">
		<app-form-by-key
			*ngIf="formReady"
			[formKey]="readConfigFrom"
			[submission]="submission"
			[readOnly]="data.isView"
			[enableFormSubmit]="true"
			(onSubmit)="onSubmit($event)"
			(onCustomEvent)="onCustomEvent($event)"
			(onFormLoad)="onFormLoad()"
		>
		</app-form-by-key>
	</ng-container>

	<ng-template #sameResourceConfig>
		<app-form-by-key
			*ngIf="formReady"
			[formKey]="data.isEndpoint ? data.displayFormKey : data.resource"
			[submission]="submission"
			[readOnly]="data.isView"
			[enableFormSubmit]="true"
			(onSubmit)="onSubmit($event)"
			(onCustomEvent)="onCustomEvent($event)"
			(onFormLoad)="onFormLoad()"
		>
		</app-form-by-key>
	</ng-template>
</div>
